require('./promo-codes-edit-container.scss')

module.exports = {
  template: require('./promo-codes-edit-container.pug')()
  controller: require('./promo-codes-edit-container.ctrl')
  bindings:
    promoCode: '<'
}
